import { camelCase, cloneDeep, upperFirst } from 'lodash-es';
import type { App } from 'vue';

/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-04-27 09:18:20
 * @LastEditors: luckymiaow
 */
export const withInstall = <T>(component: T, alias?: string): T & { install: (app: any) => void } => {
  const comp = component as any;
  comp.install = (app: App) => {
    app.component(componentName(comp.name || alias || componentFileName(comp)), component as any);
  };
  return component as T & any;
};

export function componentFileName(component: any): string {
  const fileName = component.__file;
  const name = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  return name;
}

export function componentName(name: string): string {
  return `C${name}`;
}

export function _camelCase<T extends object>(obj: T): T {
  let result: Record<string, any> = {};
  for (let key in obj) {
    result[camelCase(key)] = obj;
  }
  return result as T;
}

export function deepCopy<T>(origin: T): T {
  return cloneDeep(origin); // 把新的target 返回出去
}
